/** @format */

import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchBrokerObjectService } from 'services/apiService';
import * as actionTypes from 'stateContainer/action-types';
import { push } from 'connected-react-router';

function* workerSaga({ payload }) {
  try {
    const response = yield call(fetchBrokerObjectService, payload);
    if (response.data.status == 'success') {
      yield put({
        type: actionTypes.BROKER_OBJECT_SUCCESS,
        payload: response.data.data
      });
    } else {
      throw new Error('Fetch broker failed');
    }
  } catch (error) {
    yield put({ type: actionTypes.BROKER_OBJECT_ERROR, error });
    yield put(push('/404'));
  }
}

export function* brokerObjectSaga() {
  yield takeLatest(actionTypes.BROKER_OBJECT_REQUESTED, workerSaga);
}
